import React, {useState} from "react";
import {connect} from "react-redux";
import {respondToRegCompanyInvitation} from "../../actions/auth";
import PersonMain from "./PersonMain";
import PersonRequest from "./PersonRequest";
import PersonDetails from "./PersonDetails";
import {selectPerson} from "../../actions/people";

export function Person(props) {

    // initiate checkbox values using existing user roles from global state, passed as props
    const [roleCa, setRoleCa] = useState(props.person.croles["Company Admin"] ? props.person.croles["Company Admin"] : false);
    const [roleCreator, setRoleCreator] = useState(props.person.croles.Creator ? props.person.croles.Creator : false);

    const handleClick = (id) => {
        props.currentTab === "by_company" && props.selectPerson(id);
    }

    return (
        <>
            <div className="flex-row space-btwn">       
                <PersonMain 
                    person={props.person} 
                    onClick={() => handleClick(props.person.user_id)} 
                    currentTab={props.currentTab}
                />
                {props.person.id && 
                    <PersonRequest 
                        person={props.person} 
                        roleCa={roleCa}
                        roleCreator={roleCreator}
                    />
                }
            </div>
            {props.currentTab !== "by_project" && 
                <PersonDetails 
                    person={props.person} 
                    tab={props.currentTab}
                    open={props.person.card_open}
                    roleCa={roleCa}
                    setRoleCa={setRoleCa}
                    roleCreator={roleCreator}
                    setRoleCreator={setRoleCreator}
                    userBoxId={props.userBoxId}
                />
            }
        </>
    )
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, { respondToRegCompanyInvitation, selectPerson })(Person);